var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavori(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.3 40.1",
    style: {
      enableBackground: "new 0 0 42.3 40.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M33.2,40c-0.2,0-0.5-0.1-0.7-0.2l-11.5-7.1L9.6,39.8c-0.4,0.3-1,0.2-1.4-0.1c-0.4-0.3-0.6-0.8-0.5-1.3l3.2-13.1 L0.7,16.6c-0.4-0.3-0.5-0.9-0.4-1.3s0.6-0.8,1.1-0.9l13.4-1l5.1-12.5c0.2-0.5,0.6-0.8,1.2-0.8s1,0.3,1.2,0.8l5.1,12.5l13.4,1 c0.5,0,0.9,0.4,1.1,0.9s0,1-0.4,1.3l-10.3,8.7l3.2,13.1c0.1,0.5-0.1,1-0.5,1.3C33.7,39.9,33.4,40,33.2,40z M4.6,16.7l8.5,7.2 c0.4,0.3,0.5,0.8,0.4,1.2L10.9,36l9.5-5.9c0.4-0.2,0.9-0.2,1.3,0l9.5,5.9l-2.6-10.9c-0.1-0.5,0-0.9,0.4-1.2l8.5-7.2l-11.2-0.8 c-0.5,0-0.9-0.3-1.1-0.8L21.1,4.7l-4.3,10.4c-0.2,0.4-0.6,0.7-1.1,0.8L4.6,16.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavori);
export default __webpack_public_path__ + "static/media/Favori.01c42d12.svg";
export { ForwardRef as ReactComponent };